export const appConfig = {
  loginUserStorageKey: "loginUser",
  loginPassword: "Innominds123",
  headerHeight: 80,
  dashboardStackHeight: 120
};

// Bid Status Values
const tenderAwaited = "Tender Awaited";
const tenderReleased = "Tender Released";
const bidDropped = "Bid Dropped";
const bidSubmitted = "Bid Submitted";
const tenderCancelled = "Tender Cancelled";
const reTendered = "Re-Tendered with same scope";
const L1 = "L1";
const lost = "Lost";
const LOILOA = "LoI/LoA";
const lostL1 = "Lost-L1";

export const availProjectBidStatus = {
  tenderAwaited,
  tenderReleased,
  bidDropped,
  bidSubmitted,
  tenderCancelled,
  reTendered,
  L1,
  lost,
  LOILOA,
  lostL1,
};

export const tenderMaturityOptions = [
  {
    value: "Pre Tender",
    label: "Pre Tender",
  },
  {
    value: "DPR",
    label: "DPR",
  },
  {
    value: "NIT",
    label: "NIT",
  },
  {
    value: "RFP",
    label: "RFP",
  },
  {
    value: "RFQ",
    label: "RFQ",
  },
];

export const tenderOptions = [
  {
    value: tenderAwaited,
    label: tenderAwaited,
  },
  {
    value: tenderReleased,
    label: tenderReleased,
  },
];

export const tenderReleasedOptions = [
  {
    value: bidDropped,
    label: bidDropped,
  },
  {
    value: bidSubmitted,
    label: bidSubmitted,
  },
  {
    value: tenderCancelled,
    label: tenderCancelled,
  },
  {
    value: reTendered,
    label: reTendered,
  },
];

export const bidSubmittedOptions = [
  {
    value: L1,
    label: L1,
  },
  {
    value: lost,
    label: lost,
  },
  {
    value: tenderCancelled,
    label: tenderCancelled,
  },
  {
    value: reTendered,
    label: reTendered,
  },
];

export const l1Options = [
  {
    value: LOILOA,
    label: LOILOA,
  },
  {
    value: lostL1,
    label: lostL1,
  },
  {
    value: tenderCancelled,
    label: tenderCancelled,
  },
  {
    value: reTendered,
    label: reTendered,
  },
];

export const yesOrNoStatusOptions = [
  {
    value: "yes",
    label: "Yes",
  },
  {
    value: "no",
    label: "No",
  },
];

export const valueSlabs = {
  slab500: "0-500",
  slab1000: "500-1000",
  slabMoreThan1000: ">=1000",
};

export const projectValueSlabOptions = [
  {
    value: valueSlabs.slab500,
    label: valueSlabs.slab500,
  },
  {
    value: valueSlabs.slab1000,
    label: valueSlabs.slab1000,
  },
  {
    value: valueSlabs.slabMoreThan1000,
    label: valueSlabs.slabMoreThan1000,
  },
];

export const priceVariationOptions = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
  { value: "Do Not Know", label: "Do Not Know" },
];

export const opportunityQualificationOptions = [
  { value: "Cold", label: "Cold" },
  { value: "Warm", label: "Warm" },
  { value: "Hot", label: "Hot" },
];

export const projectBidStatusObj = {
  rejected: "rejected",
  approved: "approved",
  bidSubmitted: "bid submitted",
  loss: "loss",
  win: "win",
  submitted: "submitted",
  drafted: "drafted",
  savedAsDraft: "savedasdraft",
  dropped: "dropped",
  cancelled: "cancelled",
  droppedAfterGoNoGo: "dropped after gonogo",
  pendingForApproval: "pending for approval"
};

export const approvedWinLossBidStatuses = [
  projectBidStatusObj.approved,
  "bidSubmitted",
  projectBidStatusObj.loss,
  projectBidStatusObj.win,
];

export const nonBidDroppedStatuses = [
  projectBidStatusObj.rejected,
  "bidSubmitted",
  projectBidStatusObj.win,
  projectBidStatusObj.loss,
];

export const BidPriorityOptions = [
  {
    value: "Low",
    label: "Low",
  },
  {
    value: "High",
    label: "High",
  }, {
    value: "No Selection",
    label: "No Selection"
  }
];


